// src/contexts/LoaderContext.jsx
import React, { useState, useContext, createContext, useCallback, useRef, useEffect } from 'react';

const LoaderContext = createContext(null);

const MIN_DURATION = 600; // ms minimum d'affichage

export const useLoader = () => {
  const context = useContext(LoaderContext);
  if (!context) {
    throw new Error('useLoader doit être utilisé dans un LoaderProvider');
  }
  return context;
};

export const LoaderProvider = ({ children }) => {
  const [visible, setVisible] = useState(false);
  const startTimeRef = useRef(null);
  const timeoutRef = useRef(null);

  const showLoader = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    startTimeRef.current = Date.now();
    setVisible(true);
  }, []);

  const hideLoader = useCallback(() => {
    const elapsed = Date.now() - (startTimeRef.current || Date.now());
    const remaining = Math.max(0, MIN_DURATION - elapsed);

    if (remaining > 0) {
      timeoutRef.current = setTimeout(() => {
        setVisible(false);
      }, remaining);
    } else {
      setVisible(false);
    }
  }, []);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  return (
    <LoaderContext.Provider value={{ loaderVisible: visible, showLoader, hideLoader }}>
      {children}
    </LoaderContext.Provider>
  );
};